import { cn } from "@/lib/utils";
import type { Ticket } from "@/services/ticketsService";
import { STATUSES } from "./ticketConstants";
import { TicketCard } from "./TicketCard";

/** Flat list, grouped by status heading. No sort/filter/resize here —
 * that's what Table view is for; this is a lighter-weight linear scan. */
export function ListView({
  tickets,
  isCrossTenant,
  onOpen,
}: {
  tickets: Ticket[];
  isCrossTenant: boolean;
  onOpen: (id: string) => void;
}) {
  return (
    <div className="space-y-6">
      {STATUSES.map((st) => {
        const inGroup = tickets.filter((t) => t.status === st.key);
        if (inGroup.length === 0) return null;
        return (
          <div key={st.key}>
            <div className={cn("mb-2 inline-flex items-center gap-2 rounded-full border px-3 py-1 text-xs font-semibold", st.style)}>
              <span className={cn("h-2 w-2 rounded-full", st.dot)} />
              {st.label}
              <span className="rounded-full bg-card/70 px-1.5 tabular-nums">{inGroup.length}</span>
            </div>
            <div className="space-y-2">
              {inGroup.map((t) => (
                <TicketCard key={t.id} ticket={t} showTenant={isCrossTenant} onOpen={() => onOpen(t.id)} />
              ))}
            </div>
          </div>
        );
      })}
      {tickets.length === 0 ? (
        <p className="py-16 text-center text-sm text-muted-foreground">No tickets</p>
      ) : null}
    </div>
  );
}
